import { createRootRouteWithContext } from "@tanstack/react-router";
import { RouterAppShell } from "../router/app-shell";
import type { RouterContext } from "../router/auth";
import { RouterError, RouterPending } from "../router/components";
import "../router/metadata";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RouterAppShell,
  pendingComponent: RouterPending,
  errorComponent: RouterError,
});
